function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 350,
    height: 350,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "background",
    style: {
      fill: "rgb(255, 102, 0)"
    },
    d: "M 350,350 0,350 0,0 l 350,0 0,350 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "letter_o",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    d: "m 43.07789,321.77478 c -12.673527,0 -24.106883,-8.06959 -24.106883,-25.70382 0,-17.63421 11.433356,-25.7038 24.106883,-25.7038 12.673527,0 24.089894,8.06959 24.089894,25.7038 0,17.63422 -11.416367,25.70382 -24.089894,25.70382 m 0,-40.56887 c -9.581594,0 -11.331424,8.63023 -11.331424,14.86505 0,6.23485 1.74983,14.88207 11.331424,14.88207 9.581594,0 11.331424,-8.64722 11.331424,-14.88207 0,-6.23482 -1.74983,-14.86505 -11.331424,-14.86505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "letter_r",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    d: "m 75.959576,271.65166 12.197845,0 0,5.72518 c 2.327444,-3.09194 8.052616,-6.72751 13.421029,-6.72751 0.50966,0 1.13824,0 1.66489,0.068 l 0,12.04495 -0.62858,0 c -5.572279,0 -11.671202,0.86642 -13.641884,5.19853 l 0,32.39734 -13.0133,0 0,-48.70644 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "letter_a",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    d: "m 137.30386,316.11774 c -4.96068,3.26181 -10.32909,4.84176 -16.10523,4.84176 -9.08892,0 -14.47432,-6.04795 -14.47432,-14.16853 0,-10.9067 10.0233,-16.66585 30.68149,-18.9933 l 0,-2.71819 c 0,-3.53364 -2.68421,-5.60624 -7.64489,-5.60624 -4.96069,0 -8.98699,1.97068 -11.89205,5.60624 l -8.64722,-4.9267 c 4.53597,-6.35375 11.45034,-9.53062 20.74313,-9.53062 12.70751,0 19.84274,5.50432 19.84274,14.45732 0,0 -0.017,35.21747 0,35.3024 l -11.36541,0 -1.13824,-4.26414 z m -17.95699,-10.26115 c 0,3.27881 2.05563,6.33676 5.77614,6.33676 4.02631,0 7.95068,-1.66487 11.87506,-5.13056 l 0,-11.53528 c -11.97699,1.47801 -17.6512,4.56993 -17.6512,10.32909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "letter_n",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    d: "m 159.93783,272.9496 10.6179,-1.46103 1.17222,5.77615 c 5.98,-4.38307 10.73682,-6.71052 16.71682,-6.71052 10.0233,0 15.20483,5.31745 15.20483,15.85039 l 0,33.90934 -12.82642,0 0,-31.68381 c 0,-5.96302 -1.54596,-8.64723 -6.18386,-8.64723 -3.82245,0 -7.64489,1.73284 -12.01097,5.4024 l 0,34.92864 -12.69052,0 0,-47.36433 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "letter_g",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    d: "m 235.02253,309.88953 c 9.7175,-0.0679 10.54995,-9.97234 10.54995,-16.41103 0,-7.64489 -3.72052,-13.81176 -10.63489,-13.81176 -4.60393,0 -9.75148,3.36374 -9.75148,14.33841 0,5.99699 0.42471,15.96931 9.83642,15.88438 m 22.86671,-38.41132 0,46.12416 c 0,8.12057 -0.64557,21.55859 -23.83506,21.67751 -9.5816,0.068 -18.46666,-3.77148 -20.23348,-12.12989 l 12.63955,-2.03864 c 0.52665,2.3954 2.00466,4.77381 9.17387,4.77381 6.64256,0 9.83642,-3.17687 9.83642,-10.78779 l 0,-5.6742 -0.16988,-0.16989 c -2.03864,3.65256 -5.13057,7.10125 -12.5716,7.10125 -11.3654,0 -20.30142,-7.88273 -20.30142,-24.34472 0,-16.29211 9.22483,-25.41501 19.57091,-25.432 9.73449,-0.017 13.3191,4.41705 14.16853,6.74449 l -0.16989,-0.017 1.07029,-5.8271 10.82176,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "letter_e",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    d: "m 288.54015,321.24644 c -14.3554,0 -22.91768,-9.24183 -22.91768,-25.26212 0,-16.20717 8.66421,-25.432 22.71382,-25.432 14.0496,0 22.40802,8.95302 22.40802,24.78643 0,0.84943 -0.10194,1.68188 -0.10194,2.51432 l -32.43131,0 c 0.0849,9.24182 3.92437,13.89671 11.46733,13.89671 4.84176,0 8.05262,-1.95369 11.0596,-6.23483 l 9.37774,5.19852 c -4.12824,6.91438 -11.56927,10.53296 -21.57558,10.53296 m 9.61557,-31.70081 c 0,-6.50665 -3.7375,-10.34608 -9.81943,-10.34608 -5.79313,0 -9.41171,3.75449 -9.92137,10.34608 l 19.7408,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "letter_TM",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    d: "m 332.69028,253.16977 -4.72284,12.21483 -4.80779,-12.21483 -4.11125,0 0,16.10523 2.66722,0 0,-13.43801 0.0679,0 5.28347,13.43801 1.69886,0 5.24949,-13.43801 0.0849,0 0,13.43801 2.65023,0 0,-16.10523 -4.06029,0 z m -29.64518,0 0,2.14057 5.02864,0 0,13.96466 2.66721,0 0,-13.96466 5.04563,0 0,-2.14057 -12.74148,0 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.9dc4a8380682c76f45a03f8bba6e5f0a.svg";
export { ForwardRef as ReactComponent };